export const reportId = (areaId: number, periodId: string) => `${areaId}/${periodId}`;
